import { darken, lighten, makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
  },
  panelRoot: {
    marginBottom: theme.spacing(2),
    "@media print": {
      display: "none",
    },
  },
  receiptLine: {
    margin: "5px",
  },
  deleteBtn: {
    display: "inline-block",
    margin: "0px",
  },
  deleteBtnContainer: {
    cursor: "pointer",
    color: theme.palette.text.secondary,
  },
  addBtn: {
    marginLeft: "5px",
  },
  alternatesContainer: {
    textAlign: "right",
    marginTop: 20,
  },
  alternateOption: {
    minWidth: 200,
    textalign: "left",
    marginBottom: "5px",
  },
  optionBox: {
    margin: 5,
  },

  heading: {
    fontSize: theme.typography.pxToRem(20),
    flexBasis: "33.33%",
    flexShrink: 0,
    color: theme.palette.primary.main,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    marginTop: 5,
  },

  // MUI typography elements use REMs, so you can scale the global
  // font size by setting the font-size on the <html> element.
  titlesubheading: {
    color: theme.palette.text.secondary,
    fontSize: 18,
    [theme.breakpoints.up("xs")]: {
      fontSize: 12,
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: 14,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 16,
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: 18,
    },
  },
  titleheading: {
    fontSize: 20,
    [theme.breakpoints.up("xs")]: {
      fontSize: 20,
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: 24,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 26,
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: 28,
    },
  },
  fullWidthAccordion: {
    width: "100%",
  },
  dropdown: {
    minWidth: "90%",
    marginLeft: theme.spacing(0),
  },
  drawerPaper: {
    maxWidth: "66%",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
    },
  },
  cardFormatDrawer: {
    maxWidth: "600px",
    minWidth: "600px",
    [theme.breakpoints.down("md")]: {
      minWidth: "100%",
    },
  },
  indent: {
    marginLeft: "2em",
  },
  switchLabel: {
    fontSize: 18,
    fontWeight: "bold",
  },
  alignContentRight: {
    textAlign: "right",
    justifyContent: "right",
    display: "flex",
    flexDirection: "row",
  },
  cancelGrid: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
  cancelButton: {
    float: "right",
    marginTop: theme.spacing(1),
  },
  switchLabelIntegrators:{
    color: theme.palette.text.primary,
    fontSize:"1.1rem",
    "&[data-selected=true]": {
      color: theme.palette.amano.base.main,
      fontWeight:600,
    }
  },
  paperWrapper:{
    "&.selected":{
      borderColor: "rgba(0, 107, 166,0.2)",
      border:"1px solid",
    }
  },
  apiLabel: {
    "&.not-enabled": {
      color: theme.palette.text.disabled,  
    },
    "&.selected": {
      color: darken(theme.palette.amano.base.secondary.main,0.1),
    }
  },
  gridPaper:{
    "&.dontshow":{
      display:"none",
    }
  },
  toggleVisibilityButton:{
    width:"100%",
    display: 'flex',
    justifyContent:"flex-end",
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },        
  }
}));
